import { render, staticRenderFns } from "./GenitorSVCasamento.vue?vue&type=template&id=638d00c9&"
import script from "./GenitorSVCasamento.vue?vue&type=script&lang=js&"
export * from "./GenitorSVCasamento.vue?vue&type=script&lang=js&"
import style0 from "./GenitorSVCasamento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports